module.exports = __webpack_public_path__ + "static/media/rat-logo.f61a7c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/rat-logo.png
// module id = 68
// module chunks = 0